// extracted by mini-css-extract-plugin
export default {"collection_delete":"CollectionDeleteModal_collection_delete__k1Vmn"};